import { Image } from 'react-bootstrap'


const CompanyLogo = ({ logo, isBiggerThanMD }) => {
  const style = {
    width: isBiggerThanMD ? '200px' : '78px',
    height: isBiggerThanMD ? '80px' : '78px',
    marginRight: isBiggerThanMD ? '2.5rem' : 0,
    borderRadius: isBiggerThanMD ? 'unset' : '50%',
    overflow: 'hidden'
  }

  return <div style={style} className='shadow'>
    <Image className='w-100 rounded-xs-circle w-100 h-100' src={logo} style={{ objectFit: 'contain' }} />
  </div>
}

export default CompanyLogo
